import { FormInstance } from 'antd';
import { useCallback } from 'react';

import { INormalizedAddress } from '@/types';

export const useAddressFormHandler = (form: FormInstance) => {
  const handleAddressSelect = useCallback(
    (address: INormalizedAddress) => {
      form.setFieldsValue({
        userInfo: {
          province: address.province,
          city: address.city,
          residenceLocality: address.residenceLocality,
          streetType: address.streetType,
          address: address.address,
          streetNumber: address.streetNumber,
          postalCode: address.postalCode,
          countryResidence: address.countryResidence
        }
      });
    },
    [form]
  );

  return { handleAddressSelect };
};
